<script lang="ts">
  import { fly, scale } from "svelte/transition";
</script>

<svg
  class="animate"
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 1017 558"
  style="enable-background:new 0 0 1017 558;z-index:100"
  xml:space="preserve"
  out:fly={{ y: -100, duration: 400 }}
  in:fly={{ x: 100, duration: 200 }}
>
  <style type="text/css">
    .st0 {
      display: none;
      fill: url(#SVGID_1_);
      stroke: #ffffff;
      stroke-width: 2;
      stroke-miterlimit: 10;
    }
    .animate {
      animation: zoom 0.5s forwards ease-out;
    }
    @keyframes zoom {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    .animate-small {
      animation: zoom 0.5s forwards ease-out;
    }
    .st1 {
      display: none;
    }
    .st2 {
      display: inline;
      fill: #16123f;
    }
    .st3 {
      display: none;
      fill: #16123f;
    }
    .st4 {
      display: inline;
      fill: none;
    }
    .st5 {
      display: inline;
      fill: #ffffff;
    }
    .st6 {
      display: inline;
    }
    .st7 {
      fill: #16123f;
    }
    .st8 {
      display: inline;
      fill: #ff0000;
    }
    .st9 {
      fill: #ffffff;
    }
    .st10 {
      display: none;
      fill: #ffffff;
    }
    .st11 {
      display: inline;
      fill: #ed1c24;
    }
    .st12 {
      display: inline;
      fill: #ffffff;
      stroke: #737373;
      stroke-width: 2;
      stroke-miterlimit: 10;
    }
    .st13 {
      fill: #202020;
      stroke: #737373;
      stroke-width: 2;
      stroke-miterlimit: 10;
    }
    .st14 {
      fill: #e5b26e;
      stroke: #fdeca7;
      stroke-width: 5;
      stroke-miterlimit: 10;
    }
    .st15 {
      fill: #6ea1e5;
      stroke: #a7f4fd;
      stroke-width: 5;
      stroke-miterlimit: 10;
    }
    .st16 {
      fill: #e5b26e;
      stroke: #fdeca7;
      stroke-width: 4;
      stroke-miterlimit: 10;
    }
    .st17 {
      fill: none;
      stroke: #fdeca7;
      stroke-width: 4;
      stroke-miterlimit: 10;
    }
    .st18 {
      fill: none;
      stroke: #a7f4fd;
      stroke-width: 5;
      stroke-miterlimit: 10;
    }
    .st19 {
      fill: #e5b26e;
      stroke: #fdeca7;
      stroke-width: 2;
      stroke-miterlimit: 10;
    }
    .st20 {
      font-family: "AdvancedLEDBoard-7";
    }
    .st21 {
      font-size: 38px;
    }
    .st22 {
      fill: #e5b26e;
      stroke: #fdeca7;
      stroke-miterlimit: 10;
    }
    .st23 {
      font-size: 26px;
    }
    .st24 {
      font-size: 65px;
    }
  </style>
  <linearGradient
    id="SVGID_1_"
    gradientUnits="userSpaceOnUse"
    x1="-18.5876"
    y1="-543"
    x2="1106.4124"
    y2="-543"
    gradientTransform="matrix(1 0 0 -1 0 560)"
  >
    <stop offset="4.362646e-03" style="stop-color:#75C9B7" />
    <stop offset="0.4785" style="stop-color:#ABD699" />
    <stop offset="1" style="stop-color:#75C9B7" />
  </linearGradient>
  <rect x="-49" y="-115" class="st0" width="1125" height="2436" />
  <g class="st1">
    <path
      class="st2"
      d="M603.2,223H425.8c-18.1,0-32.8-14.7-32.8-32.8V76.8c0-18.1,14.7-32.8,32.8-32.8h177.5
		c18.1,0,32.8,14.7,32.8,32.8v113.5C636,208.3,621.3,223,603.2,223z"
    />
  </g>
  <path
    class="st3"
    d="M473,490h85c16.6,0,30-13.4,30-30V356c0-16.6-13.4-30-30-30h-85c-16.6,0-30,13.4-30,30v104
	C443,476.6,456.4,490,473,490z"
  />
  <g class="st1">
    <rect x="487.5" y="257.5" class="st4" width="0" height="3.9" />
  </g>
  <g class="st1">
    <rect x="522.3" y="1647" class="st4" width="0" height="3.9" />
  </g>
  <g class="st1">
    <path
      class="st5"
      d="M467,481h85c16.6,0,30-13.4,30-30V347c0-16.6-13.4-30-30-30h-85c-16.6,0-30,13.4-30,30v104
		C437,467.6,450.4,481,467,481z"
    />
  </g>
  <g class="st1">
    <path
      class="st5"
      d="M593.2,226H424.8c-18.1,0-32.8-14.7-32.8-32.8V79.8c0-18.1,14.7-32.8,32.8-32.8h168.5
		c18.1,0,32.8,14.7,32.8,32.8v113.5C626,211.3,611.3,226,593.2,226z"
    />
  </g>
  <g class="st1">
    <g class="st6">
      <path
        class="st7"
        d="M152.4,460.3c-4.4,2.6-8.8,4.8-12.9,6.6c-4,1.7-7.7,3.2-11.1,4.2c-3.9,1.4-7.7,2.5-11.3,3.3
			c-3.5,0.8-6.9,1.6-10.4,2.4c-15.2-22.4-30.4-44.7-45.5-67.1c7.7-1.9,15.5-3.7,23.2-5.3c-4.9-1.1-9.9-2.6-14.9-4.6
			c-5.9-2.3-11.7-5.4-17.2-9.3c-5.8-4.1-11.2-9.6-15.8-16.5c-5.2-7.6-8.6-15.5-10-23.4c-1.5-8.3-1-16.5,1.4-24.4s6.6-15.4,12.5-22.2
			c5.7-6.6,12.7-12.3,20.8-16.9c3.8-2.2,7.8-4.2,12-5.9c3.1-1.3,6.2-2.6,9.4-3.8c0.1,0,0.2-0.1,0.3-0.1c3.2-1.2,6.3-2.3,9.3-3.3
			c5-1.7,9.9-3.4,14.9-5c11.2,22.4,22.5,44.9,33.7,67.3c-1.6,0.5-3.2,1.1-4.8,1.6c3.9,1.6,7.7,3.5,11.3,5.8
			c5.2,3.2,10.2,7.3,14.8,12.1c5,5.1,9.3,11.5,12.8,18.8c3.6,7.5,6,15.2,7.3,22.7c1.4,8.3,1.3,16.3-0.3,23.9c-1.7,7.9-5,15.3-9.9,22
			C167.2,449.9,160.6,455.5,152.4,460.3z"
      />
      <path
        class="st7"
        d="M199.3,430.8c-11.6-24-23.1-47.9-34.7-71.9c-30.4-25.3-62.7-49.2-96.7-71.4c27.5-15.5,55.6-29.4,84.2-41.7
			c2.6,2.1,5.2,4.3,7.7,6.4c0.2-3.3,0.5-6.7,0.7-10c28.7-12,57.9-22.5,87.5-31.4c-7.2,39.8-12.2,79.5-14.9,118.9
			c9.2,24.9,18.4,49.9,27.7,74.8C240,412.4,219.5,421.1,199.3,430.8z"
      />
      <path
        class="st7"
        d="M330.4,372.7c0.8,3.2,1.6,6.5,2.4,9.7c-21.4,5.4-42.5,11.7-63.4,19.2c-20.9-59-41.9-118-62.8-177
			c21.6-7.7,43.4-14.4,65.3-20.4c12.4,11.3,24.4,22.9,36,34.7c5-15.7,10.4-31.5,16.3-47.1c22.2-4.6,44.6-8.3,67.1-11.1
			c7.9,62.1,15.8,124.2,23.7,186.3c-21.7,2.8-43.4,6.6-64.8,11.4c-0.7-3.1-1.4-6.3-2.1-9.4c-1.6,6.4-3.2,12.8-4.6,19.1
			C339.2,382.9,334.9,377.8,330.4,372.7z"
      />
      <path
        class="st7"
        d="M462.9,352.5c0.2,3.3,0.4,6.7,0.6,10c-21.8,1.3-43.6,3.5-65.3,6.8c-9.4-61.9-18.9-123.8-28.3-185.7
			c22.4-3.4,44.9-5.9,67.4-7.6c10,13.5,19.5,27.1,28.6,40.9c7.8-14.5,16.1-28.9,24.7-43.2c22.6-0.3,45.2,0.2,67.8,1.6
			c-3.9,62.5-7.7,125-11.6,187.5c-21.8-1.3-43.7-1.7-65.6-1c-0.1-3.2-0.2-6.4-0.3-9.6c-2.8,6-5.5,11.9-8.1,17.9
			C469.6,364.1,466.3,358.3,462.9,352.5z"
      />
      <path
        class="st7"
        d="M529.8,361.8c2.3-62.6,4.7-125.1,7-187.7c40.8,1.5,81.5,5.9,121.8,13c-4.2,23.8-8.4,47.5-12.6,71.3
			c-0.2,0-0.4-0.1-0.6-0.1c-2.5,14.1-5,28.2-7.5,42.4c0.6,0.1,1.2,0.2,1.9,0.3c-4.3,23.8-8.5,47.5-12.8,71.3
			C594.8,366.5,562.3,363,529.8,361.8z"
      />
      <path
        class="st7"
        d="M623.4,371.6c6.6-37.9,13.2-75.8,19.7-113.7c-8.1-1.4-16.2-2.7-24.3-3.8c3.4-23.9,6.8-47.8,10.2-71.7
			c45.7,6.5,91.1,16.6,135.6,30.3c-7.1,23.1-14.2,46.2-21.3,69.2c-7.9-2.4-15.9-4.7-23.8-6.9c-10.2,37.1-20.4,74.2-30.6,111.3
			C667.3,380.3,645.4,375.4,623.4,371.6z"
      />
      <path
        class="st7"
        d="M687,385.7c16.4-60.4,32.8-120.9,49.2-181.3c22.2,6,44.2,12.9,66,20.7c11,3.9,20.8,9.5,29,16.4
			c8.4,7.1,14.9,15.5,19.1,24.8c4.2,9.2,6.1,19.1,5.7,29.5c-0.4,10.1-3.1,20.5-8.1,31c-4,8.6-8.5,15.4-13.7,20.8
			c-4.8,5.1-9.3,9.1-13.8,12.1c-0.1,0.1-0.2,0.1-0.2,0.2c-1.7,1.1-3.4,2.2-5.2,3.1c0.3,23.7-0.2,47.3-1.5,70.6
			C772.7,413.5,730.3,397.5,687,385.7z"
      />
      <path
        class="st7"
        d="M799.6,427c11.2-24.1,22.5-48.2,33.7-72.3c0.4-39.6-1.4-79.6-5.4-119.9c28.9,11.3,57.4,24.3,85.2,38.8
			c0,3.4,0,6.7,0,10.1c2.7-1.9,5.5-3.8,8.2-5.7c27.8,14.8,54.9,31.2,81.4,49.2c-36,19.1-70.3,40.1-102.9,62.7
			c-13.5,22.9-27,45.8-40.5,68.7C839.8,446.9,819.9,436.4,799.6,427z"
      />
      <path
        class="st7"
        d="M88,419.9c3-0.6,6-1.5,8.9-2.6c2.6-0.7,5.4-1.7,8.5-3.1c3-1.3,6-2.8,8.9-4.6c5.1-3,6.3-6.8,3.6-11.4
			c-1-1.8-2.8-3.1-5.5-4c-2.6-0.9-5.8-1.7-9.6-2.5c-3.8-0.8-7.9-1.6-12.3-2.6c-4.4-0.9-9-2.4-13.6-4.2c-4.6-1.9-9.2-4.4-13.5-7.7
			c-4.4-3.2-8.4-7.6-11.9-13.1c-4-6.2-6.5-12.3-7.5-18.3c-1-6.1-0.6-11.9,1.1-17.4c1.7-5.5,4.7-10.7,8.8-15.4
			c4.1-4.8,9.2-8.9,15.1-12.2c3.1-1.8,6.3-3.3,9.6-4.7c3.3-1.4,6.2-2.6,8.8-3.6c3.1-1.1,6.1-2.2,9-3.2c6.8,12.9,13.6,25.9,20.5,38.8
			c-1.1,0.4-2.2,0.8-3.5,1.3c-1.1,0.4-2.2,0.8-3.5,1.4c-1.3,0.5-2.6,1.2-4,1.9c-0.7,0.4-1.6,0.9-2.7,1.6s-2,1.4-2.8,2.2
			c-0.8,0.8-1.4,1.8-1.8,2.9c-0.3,1.1-0.2,2.3,0.5,3.5c0.6,1.1,2.2,2,4.7,2.7s5.6,1.5,9.1,2.5c3.5,0.9,7.5,2.1,11.9,3.5
			c4.3,1.4,8.7,3.4,12.9,5.9c4.3,2.5,8.4,5.8,12.4,9.7c4,3.9,7.4,8.9,10.4,14.7c3.1,6.1,5.2,12.3,6.4,18.5s1.2,12,0.1,17.7
			c-1.1,5.6-3.5,10.9-7.1,15.8s-8.7,9.2-15.2,13.1c-3.9,2.3-7.7,4.3-11.4,5.8c-3.6,1.6-6.9,2.8-9.9,3.8c-3.4,1.2-6.6,2.2-9.7,2.8
			C105,446.1,96.5,433,88,419.9z M116.6,435.1c1.7-0.5,3.5-1.2,5.4-1.9c1.7-0.6,3.4-1.3,5.1-2.1c1.8-0.8,3.5-1.7,5.2-2.7
			c3-1.8,5.7-3.9,8-6.4c2.4-2.5,4.1-5.4,5.3-8.7c1.2-3.3,1.6-7,1.2-11c-0.4-4-1.8-8.3-4.3-13c-2.1-4-5-7.3-8.6-10s-7.6-4.9-12-6.8
			c-4.4-1.8-9-3.4-13.7-4.7c-4.7-1.3-9.3-2.7-13.7-4.1c-4.4-1.5-8.4-3.2-12-5.2c-3.5-2-6.3-4.6-8.2-7.8c-2.9-4.8-3.8-9.4-2.5-13.7
			c1.3-4.3,5.1-8.3,11.4-11.9c1-0.6,2-1.1,3.1-1.6s2.2-1,3.3-1.4c1.1-0.4,2.1-0.9,3.1-1.5c-1-1.8-2-3.6-3-5.3
			c-0.9,0.5-1.9,0.9-2.9,1.4c-1,0.4-2,0.8-3.1,1.3s-2.2,1.1-3.3,1.8c-6.8,3.9-11.3,8.8-13.7,14.7c-2.3,5.9-1.3,12.3,2.9,19.2
			c2.3,3.7,5.3,6.7,9,8.9c3.7,2.2,7.8,4.1,12.3,5.7s9.1,3,13.8,4.3c4.7,1.3,9.2,2.7,13.5,4.3c4.3,1.6,8.2,3.6,11.7,6
			s6.2,5.4,8.1,8.9c3.6,6.6,4.5,12.6,2.8,18s-5.6,9.8-11.7,13.4c-3.7,2.2-7.2,3.8-10.6,5c-1.8,0.7-3.5,1.3-5.3,1.9
			C114.5,431.6,115.6,433.4,116.6,435.1z"
      />
      <path
        class="st7"
        d="M178.3,349c-24.6-21.4-50.6-41.9-77.8-61.2c15.4-8,31-15.6,46.7-22.6c9.6,7.8,19.1,15.7,28.3,23.7
			c0.6-12.2,1.4-24.5,2.4-36.8c15.9-6.4,32-12.3,48.2-17.8c-4.7,32.9-7.9,65.7-9.5,98.3c8.2,20.9,16.4,41.8,24.7,62.7
			c-11.8,4.6-23.5,9.6-35,14.9C197,389.8,187.6,369.4,178.3,349z M218.7,384.3c-7.2-17.2-14.5-34.5-21.7-51.7
			c0.7-23,2.2-46.2,4.4-69.5c-2.1,0.8-4.1,1.6-6.1,2.4c-1.8,20.6-2.9,41-3.5,61.4c-15.1-13.7-30.8-27.1-46.9-40
			c-1.9,0.9-3.9,1.8-5.8,2.7c18.3,14.5,36,29.6,53,45.1c7.4,17.2,14.7,34.4,22.1,51.5C215.6,385.6,217.2,384.9,218.7,384.3z"
      />
      <path
        class="st7"
        d="M229.2,233.4c12-4,24.2-7.7,36.3-11.2c17.5,15.9,34.2,32.2,50.1,49c6.6-22.1,14.1-44.2,22.4-66.2
			c12.4-2.4,24.8-4.5,37.2-6.3c7.7,51.6,15.3,103.2,23,154.8c-12.3,1.8-24.7,4-36.9,6.5c-3.7-18.4-7.5-36.8-11.2-55.2
			c-5.3,17-10.1,34.1-14.4,51.2c-11.6-13.3-23.6-26.4-36.1-39.2c5,18.1,9.9,36.2,14.9,54.3c-12.1,3.3-24.2,6.9-36.1,10.9
			C262,332.4,245.6,282.9,229.2,233.4z M294.4,357.2c-10.2-34.4-20.4-68.8-30.7-103.2c22.2,20,43.1,40.9,62.7,62.4
			c7.8-28,17-56,27.6-83.9c6.4,35.3,12.7,70.7,19.1,106c1.5-0.3,3.1-0.6,4.6-0.8c-6.8-39.1-13.6-78.1-20.4-117.2
			c-1.8,0.3-3.6,0.6-5.4,1c-10.8,28.1-20.1,56.3-28,84.7c-19.9-21.7-41-42.7-63.5-62.9c-1.8,0.5-3.5,1-5.3,1.6
			c11.5,37.9,23.1,75.9,34.6,113.8C291.4,358.1,292.9,357.7,294.4,357.2z"
      />
      <path
        class="st7"
        d="M390.2,196.5c12.5-1.6,24.9-3,37.5-4.1c14.1,18.9,27.4,38.1,39.8,57.6c10.6-20.5,22-40.8,34.3-60.9
			c12.5,0,25.1,0.2,37.6,0.7c-2.1,52.1-4.3,104.2-6.4,156.4c-12.4-0.5-24.9-0.7-37.4-0.6c-0.2-18.8-0.4-37.5-0.6-56.3
			c-8.4,15.7-16.3,31.6-23.6,47.6c-8.8-15.3-18.1-30.4-28-45.3c1.5,18.7,2.9,37.4,4.4,56.1c-12.4,1-24.8,2.3-37.2,3.9
			C403.8,300,397,248.2,390.2,196.5z M430.7,330.5c-3.6-35.7-7.1-71.4-10.7-107.2c17.9,23.8,34.4,48.2,49.5,73.1
			c12.8-26.1,27-51.9,42.6-77.2c-0.4,35.9-0.7,71.8-1.1,107.7c1.6,0,3.1,0,4.7,0.1c0.7-39.6,1.3-79.3,2-118.9
			c-1.8,0-3.6-0.1-5.4-0.1c-15.8,25.6-30.2,51.6-43.2,77.9c-15.3-25.1-32.1-49.7-50.2-73.7c-1.8,0.2-3.6,0.4-5.4,0.6
			c4.2,39.4,8.4,78.9,12.6,118.3C427.6,330.8,429.1,330.6,430.7,330.5z"
      />
      <path
        class="st7"
        d="M662.8,245.6c-10.7-2.1-21.5-4-32.2-5.6c2.1-13.5,4.2-27.1,6.3-40.6c39,6,77.7,14.7,115.8,26
			c-3.9,13.1-7.8,26.2-11.7,39.3c-11.3-3.4-22.7-6.5-34.1-9.4c-9.4,37.3-18.8,74.6-28.2,111.9c-12.6-3.2-25.2-6-37.9-8.5
			C648.1,321.1,655.5,283.3,662.8,245.6z M666.1,345c8.4-36.8,16.7-73.7,25.1-110.5c9.7,2.2,19.4,4.6,29,7.1c0.5-1.8,1-3.6,1.4-5.4
			c-21.2-5.6-42.5-10.4-64-14.3c-0.3,1.8-0.7,3.7-1,5.5c9.8,1.8,19.5,3.8,29.3,5.9c-8.1,36.9-16.2,73.8-24.4,110.7
			C663,344.3,664.5,344.7,666.1,345z"
      />
      <path
        class="st7"
        d="M554.3,190.6c28,1.6,55.9,4.6,83.6,8.9c-2.1,13.5-4.2,27-6.3,40.6c-12.1-1.9-24.3-3.5-36.4-4.8
			c-0.6,5.8-1.3,11.5-1.9,17.3c11.7,1.3,23.4,2.8,35.1,4.7c-2,12.8-4,25.7-6,38.5c-11.1-1.7-22.2-3.2-33.4-4.4c-0.7,6-1.3,12-2,18
			c11.5,1.3,23,2.8,34.4,4.6c-2.1,13.5-4.3,27-6.4,40.6c-23.2-3.6-46.5-6.2-69.8-7.5C548.3,294.8,551.3,242.7,554.3,190.6z
			 M604.8,333.8c0.3-1.9,0.5-3.7,0.8-5.6c-12-1.7-24-3-36.1-4.1c1.5-17.1,3-34.1,4.6-51.2c12.2,1.1,24.5,2.5,36.7,4.1
			c0.3-1.9,0.5-3.7,0.8-5.6c-12.3-1.7-24.6-3.1-36.9-4.2c1.5-16.8,3-33.7,4.5-50.5c13.8,1.2,27.6,2.8,41.3,4.7
			c0.3-1.9,0.5-3.7,0.8-5.6c-15.6-2.2-31.3-3.9-47-5.2c-3.3,39.5-6.6,79-9.8,118.5C577.8,330.5,591.3,332,604.8,333.8z"
      />
      <path
        class="st7"
        d="M749.7,224.5c15.9,4.7,31.6,9.8,47.3,15.4c8.7,3.1,16.3,7.4,22.6,12.7s11.2,11.5,14.4,18.5
			c3.3,7,4.8,14.6,4.6,22.8c-0.2,8.2-2.3,16.8-6.3,25.8c-3.2,7.2-6.7,12.8-10.6,17.1c-3.9,4.3-7.6,7.6-11,10.1c-4,2.7-8,4.8-12,6.1
			c0.7,19,1,37.8,0.7,56.6c-13.6-6.2-27.3-11.9-41.2-17.2c-0.8-14.5-2-29-3.5-43.5c-4.4,12.5-8.8,24.9-13.2,37.4
			c-11.9-4.2-23.9-8.1-35.9-11.6C720.2,324.6,735,274.6,749.7,224.5z M758.7,334.6c4.7,1.6,9.5,2.7,14.3,3.2
			c1.3,13.8,2.4,27.7,3.1,41.4c1.8,0.7,3.5,1.4,5.3,2.1c-0.7-14.5-1.7-29-3-43.6c7.5-0.3,14.4-2.5,20.6-6.7
			c6.2-4.2,11.2-10.7,15-19.8c2.6-6.4,3.9-12.4,3.7-18c-0.2-5.7-1.6-10.9-4.1-15.7c-2.5-4.8-6.2-9-10.8-12.7
			c-4.7-3.7-10.1-6.6-16.4-8.8c-7.2-2.5-14.4-5-21.7-7.3c-12.1,37.8-24.2,75.5-36.4,113.3c1.5,0.5,3,1,4.5,1.5
			c3.7-11.3,7.4-22.6,11.1-33.9C748.8,331.2,753.7,332.9,758.7,334.6z M745.6,324.2c7.5-22.8,15-45.6,22.5-68.4
			c5.5,1.8,10.9,3.6,16.3,5.5c12.1,4.2,20.4,10.8,24.7,19.2c4.4,8.4,4.3,18.1-0.1,28.8c-4.4,10.7-10.9,17.6-19.4,20.9
			s-18.1,2.9-29.1-0.9C755.6,327.6,750.6,325.9,745.6,324.2z M767.9,311.3c0.7,0.2,1.4,0.5,2,0.7c4.7,1.7,9.2,1.9,13.4,0.6
			s7.5-4.8,9.7-10.6c2.2-5.8,2.1-10.7-0.3-14.4c-2.5-3.8-6.2-6.5-11.1-8.3c-0.7-0.3-1.4-0.5-2.1-0.8
			C775.6,289.4,771.8,300.3,767.9,311.3z"
      />
      <path
        class="st7"
        d="M849.8,358.9c1-32.7,0.4-65.7-1.7-98.9c15.8,6.8,31.5,14.1,47,21.9c0.1,12.4,0,24.7-0.4,37
			c9.9-7.3,19.9-14.4,30.1-21.3c15.2,8.4,30.3,17.3,45.1,26.7c-28.8,16.9-56.5,35-83,54.3c-11,19.6-22,39.1-33,58.7
			c-11.2-6.3-22.5-12.3-34-17.9C829.9,399.2,839.8,379.1,849.8,358.9z M848,412.6c8.8-16.5,17.5-33,26.3-49.5
			c18.4-14,37.4-27.4,57-40.3c-1.9-1.1-3.9-2.2-5.8-3.3c-17.2,11.6-33.9,23.5-50.1,35.9c1-20.4,1.4-41,1.2-61.7
			c-1.9-0.9-3.9-1.9-5.8-2.8c0.3,23.4-0.1,46.6-1.3,69.6c-8.7,16.6-17.3,33.1-26,49.7C845.1,411,846.6,411.8,848,412.6z"
      />
    </g>
  </g>
  <g class="st1">
    <path
      class="st2"
      d="M448.1,85.8v30c0,1.3-0.3,2.4-0.8,3.5s-1.3,2-2.3,2.9c-1,0.8-2.1,1.5-3.4,2s-2.6,0.7-4.1,0.7
		c-1.4,0-2.8-0.2-4-0.7c-1.3-0.5-2.4-1.1-3.3-2c-1-0.8-1.7-1.8-2.3-2.9c-0.6-1.1-0.8-2.2-0.8-3.5v-30h6.5v29.5c0,1.4,0.4,2.4,1.1,3
		c0.8,0.7,1.7,1,2.9,1s2.1-0.3,2.9-1s1.1-1.7,1.1-3V85.8H448.1z"
    />
    <path
      class="st2"
      d="M453.8,124.5V97h6.5v2.7h0.1c0.7-0.9,1.5-1.6,2.5-2.1c1-0.6,2.2-0.8,3.7-0.8c0.8,0,1.6,0.1,2.4,0.4
		c0.8,0.2,1.5,0.6,2.2,1.2c0.6,0.5,1.1,1.2,1.5,2.1s0.6,1.9,0.6,3.1v21.2h-6.5v-19.1c0-1-0.3-1.8-0.8-2.4c-0.6-0.6-1.3-0.9-2.4-0.9
		c-1.2,0-2.1,0.3-2.5,1c-0.5,0.7-0.7,1.6-0.7,2.8v18.6h-6.6V124.5z"
    />
    <path
      class="st2"
      d="M478.6,124.5V85.8h6.5v13.7h0.1c0.7-0.9,1.6-1.6,2.6-2.1s2.1-0.7,3.4-0.7c1.6,0,2.8,0.2,3.7,0.7
		c0.9,0.5,1.6,1.1,2.1,1.8c0.4,0.6,0.7,1.3,0.8,2.3c0.1,0.9,0.2,2.4,0.2,4.4v10.5c0,1.5-0.1,2.7-0.3,3.6c-0.2,0.9-0.4,1.7-0.8,2.3
		c-1.1,1.7-3,2.6-5.7,2.6c-1.6,0-2.8-0.3-3.7-0.8c-0.9-0.5-1.7-1.2-2.5-2v2.5h-6.4V124.5z M491.5,105.4c0-0.9-0.2-1.6-0.7-2.3
		s-1.3-1-2.5-1c-0.9,0-1.7,0.3-2.3,0.8c-0.6,0.6-0.9,1.3-0.9,2.1v10.7c0,1,0.3,1.8,0.9,2.5c0.6,0.6,1.4,1,2.4,1c1.1,0,1.9-0.3,2.4-1
		s0.8-1.6,0.8-2.7L491.5,105.4L491.5,105.4z"
    />
    <path
      class="st2"
      d="M503.4,124.5V97h6.5v2.9c1.3-1,2.6-1.8,3.9-2.4s2.8-0.9,4.7-0.9v5.9c-0.6-0.2-1.3-0.3-2-0.3s-1.4,0.1-2.2,0.3
		c-0.8,0.2-1.5,0.5-2.1,1c-0.7,0.5-1.2,1.1-1.7,1.8c-0.4,0.8-0.6,1.7-0.6,2.8v16.4C509.9,124.5,503.4,124.5,503.4,124.5z"
    />
    <path
      class="st2"
      d="M539.9,112.8H527v3.8c0,0.9,0.3,1.5,0.9,2c0.6,0.5,1.3,0.7,2.3,0.7c1.2,0,2-0.3,2.5-0.9
		c0.4-0.6,0.6-1.2,0.7-1.8h6.5c0,2.4-0.9,4.4-2.6,5.9c-0.9,0.8-1.9,1.4-3.1,1.8c-1.2,0.4-2.5,0.7-4,0.7c-2,0-3.8-0.4-5.2-1.1
		s-2.5-1.7-3.3-2.9c-0.5-0.7-0.8-1.6-1-2.5s-0.3-2-0.3-3.1v-9.1c0-1.1,0.1-2.2,0.3-3.1s0.5-1.8,1-2.5c0.8-1.2,1.9-2.2,3.3-2.9
		c1.4-0.7,3.2-1.1,5.2-1.1c1.5,0,2.8,0.2,4,0.7s2.2,1,3.1,1.8c1.7,1.6,2.5,3.7,2.5,6.1L539.9,112.8L539.9,112.8z M527,108.5h6.4
		v-3.2c0-1.1-0.3-1.8-0.9-2.4c-0.6-0.5-1.3-0.8-2.3-0.8s-1.8,0.3-2.3,0.8c-0.6,0.5-0.9,1.3-0.9,2.4V108.5z"
    />
    <path
      class="st2"
      d="M556.9,124.5v-2.8h-0.1c-0.8,1-1.7,1.8-2.6,2.3c-0.9,0.5-2.1,0.8-3.7,0.8c-0.8,0-1.5-0.1-2.3-0.3
		c-0.8-0.2-1.5-0.6-2.3-1.1c-0.7-0.5-1.3-1.2-1.8-2.2c-0.4-1-0.7-2.2-0.7-3.7c0-1.6,0.1-2.9,0.4-4.1c0.3-1.2,0.8-2.2,1.7-3
		c0.8-0.8,1.8-1.3,3.1-1.7s3-0.6,5-0.6c0.2,0,0.4,0,0.7,0s0.5,0,0.7,0.1c0.2,0,0.5,0.1,0.8,0.1s0.6,0,1,0.1v-2.9
		c0-0.9-0.2-1.7-0.7-2.3c-0.5-0.6-1.3-0.9-2.5-0.9c-0.8,0-1.6,0.2-2.3,0.7s-1.2,1.2-1.4,2.1h-6.3c0.2-2.5,1.1-4.5,2.9-6
		c0.8-0.7,1.9-1.3,3.1-1.7c1.2-0.4,2.5-0.6,4-0.6c1.4,0,2.6,0.2,3.8,0.5c1.2,0.4,2.2,0.9,3.1,1.6c0.8,0.7,1.5,1.6,2,2.7
		s0.8,2.4,0.8,3.8v19.2h-6.4V124.5z M556.9,112.7c-0.7-0.1-1.3-0.2-1.8-0.2c-1.4,0-2.6,0.3-3.6,0.8c-1,0.6-1.5,1.6-1.5,3.1
		c0,1.1,0.3,1.9,0.9,2.6c0.6,0.7,1.4,1,2.5,1s2-0.3,2.6-0.9s0.9-1.5,0.9-2.6L556.9,112.7L556.9,112.7z"
    />
    <path
      class="st2"
      d="M568.2,124.5V85.8h6.5V109h0.1l7.8-12h6.5l-7.7,11.2l9.3,16.4h-7.1l-5.9-11.9l-3.1,4.2v7.7L568.2,124.5
		L568.2,124.5z"
    />
  </g>
  <g class="st1">
    <path
      class="st8"
      d="M471.5,442.7V441c8.9-1.4,9.5-2.1,9.5-11.9v-41.4c0-9.8-0.8-10.7-9.5-11.8v-1.7h33.9v1.7
		c-8.7,1.4-9.6,1.9-9.6,11.8V429c0,10.1,0.7,10.7,9.6,12v1.7H471.5z"
    />
    <path
      class="st8"
      d="M513,442.7V441c8.9-1.4,9.5-2.1,9.5-11.9v-41.4c0-9.8-0.8-10.7-9.5-11.8v-1.7h33.9v1.7
		c-8.7,1.4-9.6,1.9-9.6,11.8V429c0,10.1,0.7,10.7,9.6,12v1.7H513z"
    />
  </g>
  <g class="st1">
    <g class="st6">
      <path
        class="st9"
        d="M151,442.1c-4.4,2.6-8.7,4.8-12.9,6.7c-3.9,1.8-7.6,3.3-10.9,4.5c-3.8,1.5-7.6,2.7-11,3.6s-6.7,1.8-10.1,2.8
			c-13.3-19.6-26.6-39.1-39.8-58.7c7.5-2.1,14.9-4.1,22.3-6c-4.6-0.7-9.3-1.9-13.9-3.4c-5.5-1.8-10.8-4.3-15.8-7.6
			c-5.3-3.5-10.1-8.2-14.2-14.2c-4.5-6.7-7.4-13.6-8.3-20.7c-1-7.4-0.2-14.9,2.5-22.2c2.6-7.2,7-14.2,12.8-20.6
			c5.7-6.2,12.6-11.7,20.4-16.1c3.7-2.1,7.6-4.1,11.6-5.8c3-1.3,6-2.6,9-3.8c0.1,0,0.2-0.1,0.3-0.1c3.1-1.2,6.1-2.3,9-3.4
			c4.8-1.7,9.6-3.4,14.4-5.1c9.8,19.6,19.6,39.3,29.5,58.9c-1.6,0.6-3.1,1.1-4.7,1.7c3.6,1.3,7.2,2.8,10.6,4.7
			c4.8,2.6,9.5,6.1,13.8,10.2c4.6,4.4,8.5,9.9,11.5,16.3c3.1,6.6,5.2,13.3,6.1,20.1c1,7.3,0.5,14.6-1.4,21.5
			c-2,7.2-5.6,14-10.7,20.3C165.9,431.8,159.2,437.3,151,442.1z"
      />
      <path
        class="st9"
        d="M198.2,413c-10.1-21-20.2-41.9-30.3-62.9c-28.2-21.4-58.1-41.4-89.4-59.9c26.7-15.1,54.1-28.6,81.9-40.6
			c2.4,1.8,4.8,3.6,7.2,5.4c0.3-3,0.7-5.9,1-8.9c27.9-11.7,56.3-21.9,85.1-30.5c-8.1,35.3-14.1,70.6-18.2,105.7
			c8.1,21.8,16.1,43.6,24.2,65.5C238.8,394.6,218.3,403.3,198.2,413z"
      />
      <path
        class="st9"
        d="M329.3,356.2c0.7,2.8,1.4,5.7,2.1,8.5c-21.3,5.4-42.5,11.7-63.3,19.1c-18.3-51.6-36.6-103.2-54.9-154.8
			c21-7.4,42.2-14,63.5-19.8c11.7,9.7,23,19.6,34,29.7c5.2-14,10.8-27.9,16.8-41.8c21.6-4.5,43.4-8.1,65.2-10.8
			c6.9,54.3,13.8,108.7,20.8,163c-21.7,2.8-43.3,6.5-64.7,11.3c-0.6-2.7-1.2-5.5-1.8-8.2c-1.8,5.7-3.5,11.3-5.1,17
			C337.8,364.9,333.6,360.5,329.3,356.2z"
      />
      <path
        class="st9"
        d="M461.4,336c0.2,2.9,0.3,5.8,0.5,8.7c-21.8,1.2-43.6,3.5-65.2,6.8c-8.2-54.1-16.5-108.3-24.7-162.4
			c21.8-3.3,43.6-5.8,65.5-7.4c9.6,11.7,18.8,23.6,27.7,35.6c7.7-12.7,15.8-25.4,24.2-37.9c22-0.3,43.9,0.2,65.9,1.6
			c-3.4,54.7-6.8,109.3-10.2,164c-21.8-1.3-43.7-1.7-65.5-1c-0.1-2.8-0.2-5.6-0.3-8.4c-2.8,5.2-5.5,10.5-8.2,15.7
			C468,346.1,464.7,341.1,461.4,336z"
      />
      <path
        class="st9"
        d="M528.1,344.1c2.1-54.7,4.1-109.5,6.2-164.2c39.6,1.5,79.2,5.7,118.4,12.6c-3.7,20.8-7.4,41.6-11.1,62.4
			c-0.2,0-0.4-0.1-0.6-0.1c-2.2,12.3-4.4,24.7-6.5,37c0.6,0.1,1.2,0.2,1.8,0.3c-3.7,20.8-7.4,41.6-11.2,62.4
			C593.1,348.8,560.6,345.3,528.1,344.1z"
      />
      <path
        class="st9"
        d="M621.6,353.9c5.8-33.2,11.5-66.3,17.3-99.5c-7.9-1.4-15.9-2.6-23.9-3.8c3-20.9,6-41.8,8.9-62.7
			c44.5,6.3,88.5,16.1,131.8,29.4c-6.2,20.2-12.4,40.4-18.6,60.5c-7.8-2.4-15.6-4.6-23.4-6.8c-8.9,32.5-17.8,64.9-26.7,97.4
			C665.4,362.6,643.5,357.7,621.6,353.9z"
      />
      <path
        class="st9"
        d="M685.1,368c14.3-52.9,28.7-105.7,43-158.6c21.6,5.9,43,12.6,64.2,20.1c10.7,3.8,20.3,9.1,28.4,15.5
			c8.3,6.6,14.8,14.3,19.2,22.7c4.4,8.3,6.6,17.3,6.6,26.5c0,9-2.2,18.2-6.5,27.4c-3.5,7.5-7.6,13.4-12.3,18.1
			c-4.4,4.4-8.6,7.7-12.9,10.3c-0.1,0-0.1,0.1-0.2,0.1c-1.6,0.9-3.2,1.8-4.9,2.6c1.3,21.2,1.9,42.3,1.8,63.2
			C770.7,395.7,728.4,379.7,685.1,368z"
      />
      <path
        class="st9"
        d="M797.6,409.1c9.8-21.1,19.7-42.2,29.5-63.2c-1.3-35.4-4.5-71.1-9.8-107c28.1,11,55.8,23.6,82.9,37.7
			c0.1,3,0.3,6,0.4,9c2.5-1.6,5-3.2,7.6-4.8c27,14.4,53.4,30.3,79.1,47.8c-33,15.7-64.6,33-94.6,51.8c-11.8,20-23.6,40.1-35.5,60.1
			C837.7,429.1,817.8,418.6,797.6,409.1z"
      />
      <path
        class="st7"
        d="M91.3,408.8c2.9-0.7,5.8-1.7,8.7-2.9c2.5-0.8,5.3-1.9,8.3-3.2c3-1.4,5.9-2.9,8.7-4.6c5-3,6.4-6.5,4-10.5
			c-0.9-1.5-2.6-2.7-5.1-3.3c-2.5-0.7-5.5-1.3-9.1-1.8s-7.4-1.1-11.6-1.7s-8.4-1.7-12.8-3.2c-4.3-1.5-8.5-3.6-12.5-6.3
			c-4-2.7-7.6-6.5-10.7-11.3c-3.5-5.4-5.6-10.8-6.2-16.2c-0.6-5.4,0-10.7,1.9-15.8c1.9-5.1,4.9-9.8,9-14.3s9.1-8.4,14.8-11.7
			c3-1.7,6.1-3.3,9.3-4.6c3.2-1.4,6-2.6,8.6-3.6c3-1.1,5.9-2.2,8.7-3.3c6,11.3,11.9,22.6,17.9,33.9c-1,0.4-2.2,0.8-3.4,1.4
			c-1,0.4-2.2,0.9-3.4,1.4c-1.3,0.5-2.6,1.2-3.9,1.9c-0.7,0.4-1.6,0.9-2.7,1.6c-1,0.7-2,1.4-2.8,2.1c-0.8,0.8-1.4,1.7-1.8,2.7
			s-0.3,2,0.3,3.1c0.5,1,2,1.7,4.4,2.2s5.3,1.1,8.6,1.8c3.3,0.7,7.1,1.5,11.2,2.6c4.1,1.1,8.2,2.6,12.1,4.7c4,2.1,7.8,4.8,11.4,8.2
			c3.7,3.4,6.8,7.6,9.4,12.7c2.7,5.4,4.5,10.8,5.3,16.3s0.6,10.8-0.8,15.9c-1.4,5.1-3.9,10-7.7,14.6s-8.9,8.8-15.4,12.6
			c-3.9,2.3-7.7,4.3-11.3,5.9s-6.8,3-9.8,4c-3.3,1.3-6.5,2.3-9.4,3.1C106.2,431.7,98.7,420.2,91.3,408.8z M117.9,421.1
			c1.7-0.6,3.5-1.2,5.3-2c1.6-0.7,3.3-1.4,5.1-2.2c1.7-0.8,3.5-1.7,5.2-2.7c3-1.7,5.7-3.8,8.1-6.2c2.4-2.4,4.2-5.1,5.5-8.1
			c1.3-3.1,1.8-6.4,1.7-9.9c-0.2-3.6-1.3-7.4-3.5-11.5c-1.9-3.5-4.5-6.4-7.8-8.6s-7.1-4.1-11.2-5.5c-4.2-1.4-8.5-2.6-12.9-3.6
			c-4.4-0.9-8.7-2-12.9-3.1c-4.2-1.1-7.9-2.5-11.2-4.1c-3.3-1.6-5.8-3.8-7.5-6.6c-2.5-4.2-3.2-8.3-1.8-12.2
			c1.4-3.9,5.2-7.7,11.4-11.3c1-0.6,2-1.1,3.1-1.6s2.1-1,3.2-1.4c1-0.4,2-0.9,3-1.5c-0.9-1.6-1.7-3.1-2.6-4.7
			c-0.9,0.5-1.8,0.9-2.9,1.4c-0.9,0.4-1.9,0.8-3,1.3s-2.2,1.1-3.3,1.7c-6.6,3.8-11.2,8.4-13.6,13.8c-2.5,5.4-1.8,11.1,1.9,17.2
			c2,3.3,4.7,5.8,8.2,7.6c3.4,1.8,7.3,3.4,11.5,4.6s8.6,2.3,13,3.2c4.4,0.9,8.7,2,12.7,3.2c4.1,1.2,7.7,2.9,10.9,4.8
			c3.2,2,5.7,4.5,7.4,7.7c3.1,5.8,3.7,11.1,1.9,16.1c-1.9,5-5.8,9.2-11.9,12.7c-3.6,2.1-7.1,3.8-10.5,5c-1.7,0.7-3.5,1.4-5.2,2
			C116,418,117,419.5,117.9,421.1z"
      />
      <path
        class="st7"
        d="M181.4,340.6c-22.9-18.1-47-35.3-72.1-51.5c15-7.8,30.2-15.2,45.5-22c8.9,6.6,17.7,13.3,26.3,20.1
			c1-10.9,2.2-21.8,3.6-32.8c15.5-6.2,31.2-12,47-17.3c-5.5,29.3-9.7,58.5-12.5,87.5c7.2,18.3,14.4,36.5,21.6,54.8
			c-11.7,4.6-23.4,9.6-34.9,14.8C197.7,376.4,189.6,358.5,181.4,340.6z M219.1,370.5c-6.3-15.1-12.7-30.1-19-45.2
			c1.6-20.6,3.9-41.2,6.8-61.9c-2,0.8-4,1.5-6,2.3c-2.4,18.3-4.3,36.6-5.6,54.8c-14.1-11.6-28.6-22.9-43.6-33.9
			c-1.9,0.9-3.8,1.8-5.7,2.7c17,12.3,33.4,25,49.2,38.1c6.4,15,12.9,30.1,19.3,45.1C216.1,371.8,217.6,371.1,219.1,370.5z"
      />
      <path
        class="st7"
        d="M234.7,236.1c11.7-3.9,23.5-7.5,35.4-10.9c16.5,13.5,32.3,27.5,47.5,41.9c7-19.7,14.7-39.2,23.2-58.7
			c12-2.3,24.1-4.4,36.2-6.2c6.7,45.1,13.4,90.3,20.1,135.4c-12.3,1.8-24.6,4-36.8,6.4c-3.3-16.1-6.5-32.2-9.8-48.3
			c-5.6,15.1-10.8,30.2-15.4,45.4c-11.1-11.4-22.6-22.6-34.5-33.6c4.3,15.8,8.7,31.7,13,47.5c-12.1,3.3-24.1,6.9-36,10.9
			C263.4,322.7,249.1,279.4,234.7,236.1z M294.3,343.6c-8.9-30.1-17.9-60.2-26.8-90.3c20.9,17,40.8,34.9,59.5,53.3
			c8.3-24.9,17.9-49.7,28.8-74.3c5.6,30.9,11.1,61.8,16.7,92.7c1.5-0.3,3.1-0.5,4.6-0.8c-5.9-34.2-11.9-68.3-17.8-102.5
			c-1.7,0.3-3.5,0.6-5.2,0.9c-11,24.8-20.7,49.9-29.2,75c-18.9-18.6-39-36.6-60.1-53.8c-1.7,0.5-3.4,1-5.1,1.5
			c10.1,33.2,20.2,66.4,30.3,99.5C291.3,344.5,292.8,344,294.3,343.6z"
      />
      <path
        class="st7"
        d="M391.5,200.2c12.1-1.6,24.3-2.9,36.5-4c13.6,16.4,26.4,33.1,38.5,50.1c10.5-18,21.7-35.8,33.7-53.3
			c12.2,0,24.4,0.2,36.6,0.7c-1.9,45.6-3.7,91.2-5.6,136.7c-12.4-0.5-24.8-0.7-37.2-0.6c-0.2-16.4-0.4-32.8-0.5-49.2
			c-8.3,13.8-16.2,27.7-23.6,41.7c-8.7-13.3-17.8-26.5-27.4-39.4c1.3,16.4,2.6,32.7,3.8,49.1c-12.4,1-24.7,2.3-37.1,3.9
			C403.4,290.7,397.4,245.4,391.5,200.2z M429.6,317c-3.1-31.2-6.2-62.5-9.3-93.7c17.2,20.7,33.3,41.9,48.1,63.6
			c12.8-22.9,26.8-45.5,42-67.6c-0.3,31.4-0.6,62.8-1,94.2c1.5,0,3.1,0,4.6,0.1c0.6-34.7,1.1-69.3,1.7-104c-1.8,0-3.5-0.1-5.3-0.1
			c-15.4,22.3-29.6,45.1-42.5,68.2c-15-21.9-31.2-43.3-48.7-64.2c-1.8,0.2-3.5,0.4-5.3,0.5c3.7,34.5,7.3,69,11,103.5
			C426.5,317.4,428,317.2,429.6,317z"
      />
      <path
        class="st7"
        d="M657.9,244c-10.5-2-21-3.9-31.5-5.5c1.8-11.8,3.7-23.7,5.5-35.5c38,5.9,75.7,14.3,112.8,25.4
			c-3.4,11.5-6.8,22.9-10.3,34.4c-11.1-3.3-22.2-6.4-33.4-9.2c-8.2,32.6-16.5,65.3-24.7,97.9c-12.5-3.2-25.1-6-37.7-8.4
			C645,310,651.4,277,657.9,244z M663.3,331.5c7.3-32.2,14.6-64.4,21.9-96.7c9.5,2.2,18.9,4.5,28.4,7c0.4-1.6,0.8-3.2,1.3-4.8
			c-20.7-5.5-41.5-10.1-62.5-14c-0.3,1.6-0.6,3.2-0.9,4.8c9.6,1.8,19.1,3.7,28.6,5.8c-7.1,32.3-14.2,64.5-21.3,96.8
			C660.2,330.8,661.8,331.1,663.3,331.5z"
      />
      <path
        class="st7"
        d="M551.4,194.4c27.2,1.6,54.4,4.5,81.5,8.7c-1.8,11.8-3.7,23.7-5.5,35.5c-11.9-1.8-23.7-3.4-35.7-4.7
			c-0.6,5-1.1,10.1-1.7,15.1c11.5,1.3,23,2.8,34.4,4.6c-1.7,11.2-3.5,22.4-5.2,33.7c-11-1.7-21.9-3.2-32.9-4.4
			c-0.6,5.2-1.2,10.5-1.7,15.7c11.4,1.3,22.7,2.8,34.1,4.6c-1.9,11.8-3.7,23.6-5.6,35.5c-23.1-3.6-46.3-6.1-69.5-7.5
			C546.1,285.5,548.7,240,551.4,194.4z M602.4,320.4c0.2-1.6,0.5-3.3,0.7-4.9c-11.9-1.7-23.8-3-35.8-4.1c1.3-14.9,2.7-29.8,4-44.8
			c12.1,1.1,24.1,2.4,36.1,4.1c0.2-1.6,0.4-3.3,0.7-4.9c-12.1-1.6-24.2-3-36.3-4.1c1.3-14.7,2.6-29.4,3.9-44.1
			c13.5,1.2,27,2.7,40.4,4.6c0.2-1.6,0.5-3.3,0.7-4.9c-15.3-2.1-30.6-3.8-45.9-5.1c-2.9,34.6-5.7,69.1-8.6,103.7
			C575.6,317.1,589,318.5,602.4,320.4z"
      />
      <path
        class="st7"
        d="M741.7,227.5c15.5,4.5,30.8,9.5,46.1,15c8.5,3,15.9,7.1,22.2,12c6.3,5,11.1,10.6,14.5,16.9s5.1,13.1,5.3,20.5
			c0.2,7.3-1.6,14.9-5.1,22.8c-2.8,6.3-6,11.2-9.6,14.8c-3.6,3.7-7,6.5-10.2,8.5c-3.8,2.3-7.6,3.9-11.4,5
			c1.5,16.9,2.5,33.8,3.1,50.6c-13.5-6.1-27.2-11.9-41-17.1c-1.4-12.9-3.1-25.8-5.1-38.8c-3.8,10.9-7.7,21.8-11.5,32.7
			c-11.9-4.2-23.8-8-35.8-11.6C715.9,315,728.8,271.3,741.7,227.5z M753.8,325.1c4.6,1.6,9.3,2.7,14.1,3.3c1.8,12.4,3.3,24.7,4.6,37
			c1.7,0.7,3.5,1.4,5.2,2.1c-1.3-12.9-2.8-25.9-4.7-38.9c7.3,0,13.9-1.7,19.7-5.2s10.5-9.1,13.8-17.1c2.3-5.6,3.3-10.9,2.9-15.9
			c-0.4-5-1.9-9.8-4.6-14.1c-2.6-4.3-6.2-8.2-10.8-11.7c-4.6-3.4-10-6.2-16.1-8.4c-7-2.5-14.1-4.8-21.2-7.1
			c-10.6,33-21.2,66-31.8,99.1c1.5,0.5,3,1,4.5,1.5c3.2-9.9,6.5-19.8,9.7-29.6C744,321.8,748.9,323.4,753.8,325.1z M740.7,315.5
			c6.5-20,13.1-39.9,19.6-59.9c5.3,1.8,10.7,3.6,16,5.4c11.8,4.1,20,10.2,24.5,17.9c4.5,7.7,4.8,16.2,1,25.6s-9.9,15.3-18,17.9
			s-17.5,1.9-28.4-1.9C750.5,318.8,745.6,317.1,740.7,315.5z M762,304.7c0.7,0.2,1.3,0.5,2,0.7c4.6,1.6,9,2,13,1s7.1-4,9-9.1
			s1.7-9.4-0.8-12.8s-6.2-6-11-7.7c-0.7-0.2-1.4-0.5-2.1-0.7C768.7,285.6,765.3,295.2,762,304.7z"
      />
      <path
        class="st7"
        d="M843.1,350.4c-0.5-29.2-2.3-58.7-5.5-88.4c15.4,6.6,30.7,13.7,45.7,21.3c0.6,11.1,1,22.1,1.2,33.1
			c9.1-6.1,18.4-12,27.8-17.9c14.8,8.2,29.5,16.9,44,26c-26.5,14-52,29-76.5,45.1c-9.6,17.1-19.2,34.2-28.8,51.4
			c-11.2-6.3-22.4-12.2-33.9-17.8C825.7,385.7,834.4,368,843.1,350.4z M843.9,398.6c7.7-14.4,15.3-28.9,23-43.3
			c17-11.7,34.6-22.9,52.7-33.6c-1.9-1.1-3.8-2.2-5.7-3.3c-15.8,9.6-31.3,19.7-46.3,30.1c0-18.3-0.5-36.7-1.5-55.2
			c-1.9-0.9-3.8-1.8-5.7-2.7c1.2,20.9,1.8,41.7,1.7,62.3c-7.6,14.5-15.1,29-22.7,43.5C841,397,842.4,397.8,843.9,398.6z"
      />
    </g>
  </g>
  <g class="st1">
    <path
      class="st2"
      d="M492.1,159.3v-17.8h-3.3v-2.8h9.5v2.8H495v17.8H492.1z"
    />
    <path
      class="st2"
      d="M499.6,159.3v-20.6h2.9v8.8h3.6v-8.8h2.9v20.6h-3v-9.2h-3.6v9.2H499.6z"
    />
    <path
      class="st2"
      d="M511.6,159.3v-20.6h8.6v2.8h-5.7v6h5v2.8h-5v6h5.7v2.9h-8.6V159.3z"
    />
  </g>
  <circle class="st10" cx="119.5" cy="417.5" r="9.5" />
  <circle class="st10" cx="374.5" cy="319.5" r="10.5" />
  <circle class="st10" cx="727.5" cy="347.5" r="10.5" />
  <circle class="st10" cx="204.5" cy="265.5" r="10.5" />
  <g class="st1">
    <path
      class="st11"
      d="M484.7,467.7v-16.9h4.1v6h0.1c0.5-0.4,1-0.7,1.6-0.9c0.6-0.2,1.3-0.3,2.2-0.3c1,0,1.8,0.1,2.3,0.3
		c0.5,0.2,1,0.5,1.3,0.8s0.4,0.6,0.5,1s0.1,1.1,0.1,1.9v4.6c0,0.7-0.1,1.2-0.2,1.6s-0.3,0.7-0.5,1c-0.7,0.8-1.9,1.1-3.6,1.1
		c-1,0-1.8-0.1-2.3-0.4c-0.5-0.2-1.1-0.5-1.6-0.9v1.1L484.7,467.7L484.7,467.7z M492.9,459.4c0-0.4-0.1-0.7-0.4-1s-0.8-0.4-1.6-0.4
		c-0.6,0-1.1,0.1-1.5,0.4c-0.4,0.2-0.6,0.6-0.6,0.9v4.7c0,0.4,0.2,0.8,0.6,1.1c0.4,0.3,0.9,0.4,1.5,0.4c0.7,0,1.2-0.2,1.5-0.5
		s0.5-0.7,0.5-1.2V459.4z"
    />
    <path
      class="st11"
      d="M512.2,462.6h-8.1v1.6c0,0.4,0.2,0.7,0.5,0.9c0.4,0.2,0.9,0.3,1.5,0.3c0.8,0,1.3-0.1,1.6-0.4
		c0.3-0.3,0.4-0.5,0.5-0.8h4.1c0,1.1-0.6,1.9-1.7,2.6c-0.5,0.3-1.2,0.6-1.9,0.8c-0.8,0.2-1.6,0.3-2.5,0.3c-1.3,0-2.4-0.2-3.3-0.5
		s-1.6-0.7-2.1-1.3c-0.3-0.3-0.5-0.7-0.6-1.1s-0.2-0.9-0.2-1.4v-4c0-0.5,0.1-0.9,0.2-1.4c0.1-0.4,0.3-0.8,0.6-1.1
		c0.5-0.5,1.2-0.9,2.1-1.3c0.9-0.3,2-0.5,3.3-0.5c0.9,0,1.8,0.1,2.6,0.3c0.8,0.2,1.4,0.5,2,0.8c1.1,0.7,1.6,1.6,1.6,2.7v3.5H512.2z
		 M504.1,460.7h4v-1.4c0-0.5-0.2-0.8-0.5-1s-0.9-0.3-1.5-0.3s-1.1,0.1-1.5,0.3c-0.4,0.2-0.5,0.6-0.5,1V460.7z"
    />
    <path
      class="st11"
      d="M515.2,455.6V452h4.1v3.7h2.5v1.9h-2.5v6.7c0,0.3,0,0.5,0.1,0.7s0.2,0.3,0.5,0.4s0.5,0.1,0.8,0.1s0.7,0,1.1,0
		v2.3h-1.7c-0.9,0-1.7-0.1-2.4-0.3c-0.6-0.2-1.1-0.4-1.5-0.7c-0.4-0.3-0.7-0.6-0.8-0.9c-0.2-0.3-0.3-0.7-0.3-1v-7.3H513v-1.9h2.2
		V455.6z"
    />
    <path
      class="st11"
      d="M531.2,467.7v-1.2h-0.1c-0.5,0.4-1.1,0.8-1.6,1s-1.3,0.4-2.3,0.4c-0.5,0-1,0-1.5-0.1s-1-0.2-1.4-0.5
		c-0.5-0.2-0.8-0.5-1.1-1s-0.4-1-0.4-1.6c0-0.7,0.1-1.3,0.3-1.8s0.5-0.9,1-1.3c0.5-0.3,1.1-0.6,2-0.8c0.8-0.2,1.9-0.2,3.2-0.2
		c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0,0.4,0c0.1,0,0.3,0,0.5,0s0.4,0,0.6,0v-1.3c0-0.4-0.1-0.8-0.4-1c-0.3-0.3-0.8-0.4-1.6-0.4
		c-0.5,0-1,0.1-1.5,0.3c-0.4,0.2-0.7,0.5-0.9,0.9h-4c0.1-1.1,0.7-2,1.9-2.6c0.5-0.3,1.2-0.6,1.9-0.7c0.8-0.2,1.6-0.3,2.5-0.3
		s1.7,0.1,2.4,0.2c0.8,0.2,1.4,0.4,2,0.7c0.5,0.3,1,0.7,1.3,1.2s0.5,1,0.5,1.7v8.4L531.2,467.7L531.2,467.7z M531.2,462.5
		c-0.5,0-0.8-0.1-1.1-0.1c-0.9,0-1.6,0.1-2.3,0.4c-0.6,0.2-0.9,0.7-0.9,1.3c0,0.5,0.2,0.8,0.6,1.1c0.4,0.3,0.9,0.4,1.6,0.4
		c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.1L531.2,462.5L531.2,462.5z"
    />
  </g>
  <circle class="st10" cx="467.8" cy="276.7" r="10.2" />
  <circle class="st10" cx="602.8" cy="317.7" r="9.2" />
  <circle class="st10" cx="717.5" cy="240.5" r="10.5" />
  <circle class="st10" cx="863.5" cy="292.5" r="10.5" />
  <image
    style="overflow:visible;"
    width="668"
    height="472"
    xlink:href="../../../../../../../../../Users/jacobkaled/Desktop/Screenshot 2022-07-06 at 12.49.19 AM.png"
    transform="matrix(0.5 0 0 0.5 -409 583)"
  />
  <g class="st1">
    <rect x="59.2" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="59.2" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="59.2" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="59.2" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="59.2" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="95.7" y="317.4" class="st12" width="36.6" height="37.7" />
    <rect x="20.6" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="20.6" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="20.6" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="20.6" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="20.6" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="248" y="317.4" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="399.3" y="317.4" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="551.7" y="317.4" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="704" y="317.4" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="856.3" y="317.4" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="203.3" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="355.1" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="932.4" y="242" class="st12" width="36.6" height="37.7" />
    <rect x="932.4" y="280.8" class="st12" width="36.6" height="37.7" />
    <rect x="932.4" y="319.5" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="87" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="87" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="87" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="59.2" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="-17" y="278.7" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="393.9" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="59.2" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="-16" y="239.9" class="st12" width="36.6" height="37.7" />
    <rect x="135.3" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="211.5" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="287.6" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="249" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="362.8" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="324.2" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="438.9" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="400.3" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="515.1" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="476.5" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="552.7" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="667.4" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="628.8" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="743.6" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="705" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="819.7" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="781.1" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="895.9" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="857.3" y="164.5" class="st12" width="36.6" height="37.7" />
    <rect x="856.3" y="125.8" class="st12" width="36.6" height="37.7" />
    <rect x="96.7" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="172.9" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="514.7" y="125.3" class="st12" width="36.6" height="37.7" />
    <rect x="438.5" y="125.3" class="st12" width="36.6" height="37.7" />
    <rect x="476.1" y="86.6" class="st12" width="36.6" height="37.7" />
    <rect x="476.1" y="125.3" class="st12" width="36.6" height="37.7" />
    <rect x="628.7" y="87.3" class="st12" width="36.6" height="37.7" />
    <rect x="628.7" y="126.1" class="st12" width="36.6" height="37.7" />
    <rect x="666.2" y="126.1" class="st12" width="36.6" height="37.7" />
    <rect x="666.4" y="87" class="st12" width="36.6" height="37.7" />
    <rect x="704.4" y="125.6" class="st12" width="36.6" height="37.7" />
    <rect x="742" y="86.9" class="st12" width="36.6" height="37.7" />
    <rect x="742" y="125.6" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="431.6" class="st12" width="36.6" height="37.7" />
    <rect x="591.3" y="469.3" class="st12" width="36.6" height="37.7" />
  </g>

  <rect x="99" y="186" class="st13" width="36" height="36" />
  <rect x="99" y="223" class="st13" width="36" height="36" />
  <rect x="99" y="260" class="st13" width="36" height="36" />
  <rect x="99" y="297" class="st13" width="36" height="36" />
  <rect x="99" y="331" class="st13" width="36" height="36" />
  <rect x="135" y="295" class="st13" width="36" height="36" />
  <rect x="61" y="186" class="st13" width="36" height="36" />
  <rect x="61" y="223" class="st13" width="36" height="36" />
  <rect x="61" y="260" class="st13" width="36" height="36" />
  <rect x="61" y="297" class="st13" width="36" height="36" />
  <rect x="61" y="331" class="st13" width="36" height="36" />
  <rect x="174" y="186" class="st13" width="36" height="36" />
  <rect x="174" y="223" class="st13" width="36" height="36" />
  <rect x="174" y="260" class="st13" width="36" height="36" />
  <rect x="174" y="297" class="st13" width="36" height="36" />
  <rect x="174" y="331" class="st13" width="36" height="36" />
  <rect x="136" y="186" class="st13" width="36" height="36" />
  <rect x="136" y="223" class="st13" width="36" height="36" />
  <rect x="136" y="260" class="st13" width="36" height="36" />
  <rect x="136" y="297" class="st13" width="36" height="36" />
  <rect x="136" y="331" class="st13" width="36" height="36" />
  <rect x="249" y="186" class="st13" width="36" height="36" />
  <rect x="249" y="223" class="st13" width="36" height="36" />
  <rect x="249" y="260" class="st13" width="36" height="36" />
  <rect x="249" y="297" class="st13" width="36" height="36" />
  <rect x="249" y="331" class="st13" width="36" height="36" />
  <rect x="285" y="295" class="st13" width="36" height="36" />
  <rect x="211" y="186" class="st13" width="36" height="36" />
  <rect x="211" y="223" class="st13" width="36" height="36" />
  <rect x="211" y="260" class="st13" width="36" height="36" />
  <rect x="211" y="297" class="st13" width="36" height="36" />
  <rect x="211" y="331" class="st13" width="36" height="36" />
  <rect x="324" y="186" class="st13" width="36" height="36" />
  <rect x="324" y="223" class="st13" width="36" height="36" />
  <rect x="324" y="260" class="st13" width="36" height="36" />
  <rect x="324" y="297" class="st13" width="36" height="36" />
  <rect x="324" y="331" class="st13" width="36" height="36" />
  <rect x="286" y="186" class="st13" width="36" height="36" />
  <rect x="286" y="223" class="st13" width="36" height="36" />
  <rect x="286" y="260" class="st13" width="36" height="36" />
  <rect x="286" y="297" class="st13" width="36" height="36" />
  <rect x="286" y="331" class="st13" width="36" height="36" />
  <rect x="398" y="186" class="st13" width="36" height="36" />
  <rect x="398" y="223" class="st13" width="36" height="36" />
  <rect x="398" y="260" class="st13" width="36" height="36" />
  <rect x="398" y="297" class="st13" width="36" height="36" />
  <rect x="398" y="331" class="st13" width="36" height="36" />
  <rect x="434" y="295" class="st13" width="36" height="36" />
  <rect x="360" y="186" class="st13" width="36" height="36" />
  <rect x="360" y="223" class="st13" width="36" height="36" />
  <rect x="360" y="260" class="st13" width="36" height="36" />
  <rect x="360" y="297" class="st13" width="36" height="36" />
  <rect x="360" y="331" class="st13" width="36" height="36" />
  <rect x="473" y="186" class="st13" width="36" height="36" />
  <rect x="473" y="223" class="st13" width="36" height="36" />
  <rect x="473" y="260" class="st13" width="36" height="36" />
  <rect x="473" y="297" class="st13" width="36" height="36" />
  <rect x="473" y="331" class="st13" width="36" height="36" />
  <rect x="435" y="186" class="st13" width="36" height="36" />
  <rect x="435" y="223" class="st13" width="36" height="36" />
  <rect x="435" y="260" class="st13" width="36" height="36" />
  <rect x="435" y="297" class="st13" width="36" height="36" />
  <rect x="435" y="331" class="st13" width="36" height="36" />
  <rect x="548" y="186" class="st13" width="36" height="36" />
  <rect x="548" y="223" class="st13" width="36" height="36" />
  <rect x="548" y="260" class="st13" width="36" height="36" />
  <rect x="548" y="297" class="st13" width="36" height="36" />
  <rect x="548" y="331" class="st13" width="36" height="36" />
  <rect x="584" y="295" class="st13" width="36" height="36" />
  <rect x="510" y="186" class="st13" width="36" height="36" />
  <rect x="510" y="223" class="st13" width="36" height="36" />
  <rect x="510" y="260" class="st13" width="36" height="36" />
  <rect x="510" y="297" class="st13" width="36" height="36" />
  <rect x="510" y="331" class="st13" width="36" height="36" />
  <rect x="623" y="186" class="st13" width="36" height="36" />
  <rect x="623" y="223" class="st13" width="36" height="36" />
  <rect x="623" y="260" class="st13" width="36" height="36" />
  <rect x="623" y="297" class="st13" width="36" height="36" />
  <rect x="623" y="331" class="st13" width="36" height="36" />
  <rect x="585" y="186" class="st13" width="36" height="36" />
  <rect x="585" y="223" class="st13" width="36" height="36" />
  <rect x="585" y="260" class="st13" width="36" height="36" />
  <rect x="585" y="297" class="st13" width="36" height="36" />
  <rect x="585" y="331" class="st13" width="36" height="36" />
  <rect x="698" y="186" class="st13" width="36" height="36" />
  <rect x="698" y="223" class="st13" width="36" height="36" />
  <rect x="698" y="260" class="st13" width="36" height="36" />
  <rect x="698" y="297" class="st13" width="36" height="36" />
  <rect x="698" y="331" class="st13" width="36" height="36" />
  <rect x="734" y="295" class="st13" width="36" height="36" />
  <rect x="660" y="186" class="st13" width="36" height="36" />
  <rect x="660" y="223" class="st13" width="36" height="36" />
  <rect x="660" y="260" class="st13" width="36" height="36" />
  <rect x="660" y="297" class="st13" width="36" height="36" />
  <rect x="660" y="331" class="st13" width="36" height="36" />
  <rect x="773" y="186" class="st13" width="36" height="36" />
  <rect x="773" y="223" class="st13" width="36" height="36" />
  <rect x="773" y="260" class="st13" width="36" height="36" />
  <rect x="773" y="297" class="st13" width="36" height="36" />
  <rect x="773" y="331" class="st13" width="36" height="36" />
  <rect x="735" y="186" class="st13" width="36" height="36" />
  <rect x="735" y="223" class="st13" width="36" height="36" />
  <rect x="735" y="260" class="st13" width="36" height="36" />
  <rect x="735" y="297" class="st13" width="36" height="36" />
  <rect x="735" y="331" class="st13" width="36" height="36" />
  <rect x="848" y="186" class="st13" width="36" height="36" />
  <rect x="848" y="223" class="st13" width="36" height="36" />
  <rect x="848" y="260" class="st13" width="36" height="36" />
  <rect x="848" y="297" class="st13" width="36" height="36" />
  <rect x="848" y="331" class="st13" width="36" height="36" />
  <rect x="884" y="295" class="st13" width="36" height="36" />
  <rect x="810" y="186" class="st13" width="36" height="36" />
  <rect x="810" y="223" class="st13" width="36" height="36" />
  <rect x="810" y="260" class="st13" width="36" height="36" />
  <rect x="810" y="297" class="st13" width="36" height="36" />
  <rect x="810" y="331" class="st13" width="36" height="36" />
  <rect x="923" y="186" class="st13" width="36" height="36" />
  <rect x="923" y="223" class="st13" width="36" height="36" />
  <rect x="923" y="260" class="st13" width="36" height="36" />
  <rect x="923" y="297" class="st13" width="36" height="36" />
  <rect x="923" y="331" class="st13" width="36" height="36" />
  <rect x="885" y="186" class="st13" width="36" height="36" />
  <rect x="885" y="223" class="st13" width="36" height="36" />
  <rect x="885" y="260" class="st13" width="36" height="36" />
  <rect x="885" y="297" class="st13" width="36" height="36" />
  <rect x="885" y="331" class="st13" width="36" height="36" />
  <rect x="810" y="408" class="st13" width="46" height="46" />
  <rect x="959" y="223" class="st13" width="36" height="36" />
  <rect x="959" y="260" class="st13" width="36" height="36" />
  <rect x="959" y="297" class="st13" width="96" height="96" />
  <rect x="660" y="404" class="st13" width="36" height="36" />
  <rect x="249" y="112" class="st13" width="36" height="36" />
  <rect x="174" y="112" class="st13" width="36" height="36" />
  <rect x="211" y="65" class="st13" width="26" height="26" />
  <rect x="211" y="112" class="st13" width="36" height="36" />
  <rect x="249" y="112" class="st13" width="36" height="36" />
  <rect x="174" y="112" class="st13" width="36" height="36" />
  <rect x="111" y="35" class="st13 animate-small" width="66" height="66" />
  <rect x="211" y="112" class="st13" width="36" height="36" />
  <rect x="398" y="75" class="st13" width="36" height="36" />
  <rect x="398" y="112" class="st13" width="36" height="36" />
  <rect x="435" y="112" class="st13" width="36" height="36" />
  <rect x="99" y="368" class="st13" width="36" height="36" />
  <rect x="14" y="268" class="st13" width="16" height="16" />
  <rect x="174" y="368" class="st13" width="36" height="36" />
  <rect x="136" y="368" class="st13" width="36" height="36" />
  <rect x="249" y="368" class="st13" width="36" height="36" />
  <rect x="211" y="368" class="st13" width="36" height="36" />
  <rect x="324" y="368" class="st13" width="36" height="36" />
  <rect x="286" y="368" class="st13" width="36" height="36" />
  <rect x="174" y="404" class="st13" width="36" height="36" />
  <rect x="360" y="368" class="st13" width="36" height="36" />
  <rect x="473" y="368" class="st13" width="36" height="36" />
  <rect x="435" y="368" class="st13" width="36" height="36" />
  <rect x="548" y="368" class="st13" width="36" height="36" />
  <rect x="510" y="368" class="st13" width="36" height="36" />
  <rect x="623" y="368" class="st13" width="36" height="36" />
  <rect x="585" y="368" class="st13" width="36" height="36" />
  <rect x="698" y="368" class="st13" width="36" height="36" />
  <rect x="660" y="368" class="st13" width="36" height="36" />
  <rect x="773" y="368" class="st13" width="36" height="36" />
  <rect x="735" y="368" class="st13" width="36" height="36" />
  <rect x="848" y="368" class="st13" width="36" height="36" />
  <rect x="810" y="368" class="st13" width="36" height="36" />
  <rect x="923" y="368" class="st13" width="36" height="36" />
  <rect x="885" y="368" class="st13" width="36" height="36" />
  <rect x="860" y="420" class="st13 animate-small " width="66" height="66" />
  <rect x="99" y="149" class="st13" width="36" height="36" />
  <rect x="0" y="371" class="st13 animate-small" width="86" height="86" />
  <rect x="174" y="149" class="st13" width="36" height="36" />
  <rect x="136" y="149" class="st13" width="36" height="36" />
  <rect x="249" y="149" class="st13" width="36" height="36" />
  <rect x="211" y="149" class="st13" width="36" height="36" />
  <rect x="324" y="149" class="st13" width="36" height="36" />
  <rect x="286" y="149" class="st13" width="36" height="36" />
  <rect x="398" y="149" class="st13" width="36" height="36" />
  <rect x="360" y="149" class="st13" width="36" height="36" />
  <rect x="473" y="149" class="st13" width="36" height="36" />
  <rect x="435" y="149" class="st13" width="36" height="36" />
  <rect x="548" y="149" class="st13" width="36" height="36" />
  <rect x="510" y="149" class="st13" width="36" height="36" />
  <rect x="623" y="149" class="st13" width="36" height="36" />
  <rect x="585" y="149" class="st13" width="36" height="36" />
  <rect x="698" y="149" class="st13" width="36" height="36" />
  <rect x="660" y="149" class="st13" width="36" height="36" />
  <rect x="773" y="149" class="st13" width="36" height="36" />
  <rect x="735" y="149" class="st13" width="36" height="36" />
  <rect x="848" y="149" class="st13" width="36" height="36" />
  <rect x="810" y="149" class="st13" width="36" height="36" />
  <rect x="923" y="149" class="st13" width="36" height="36" />
  <rect x="885" y="149" class="st13" width="36" height="36" />
  <rect x="920" y="62" class="st13 animate-small" width="66" height="66" />
  <rect x="166" y="454" class="st13" width="46" height="46" />
  <rect x="251" y="434" class="st13" width="26" height="26" />
  <rect x="547.6" y="111.6" class="st13" width="36" height="36" />
  <rect x="472.6" y="111.6" class="st13" width="36" height="36" />
  <rect x="509.6" y="74.6" class="st13" width="36" height="36" />
  <rect x="509.6" y="111.6" class="st13" width="36" height="36" />
  <rect x="609.8" y="105.3" class="st13" width="46" height="46" />
  <rect x="659.8" y="112.3" class="st13" width="36" height="36" />
  <rect x="696.8" y="112.3" class="st13" width="36" height="36" />
  <rect x="657" y="35" class="st13 animate-small" width="56" height="56" />
  <rect x="734.5" y="111.9" class="st13" width="36" height="36" />
  <rect x="781.5" y="64.9" class="st13" width="26" height="26" />
  <rect x="771.5" y="111.9" class="st13" width="36" height="36" />
  <rect x="623" y="404" class="st13" width="36" height="36" />
  <rect x="633" y="480" class="st13 animate-small" width="76" height="76" />
  <rect x="548" y="75" class="st13" width="36" height="36" />
  <rect x="584.6" y="111.6" class="st13" width="36" height="36" />
  <rect x="585" y="75" class="st13" width="36" height="36" />
  <rect x="473" y="405" class="st13" width="36" height="36" />
  <rect x="548" y="405" class="st13" width="36" height="36" />
  <rect x="510" y="405" class="st13" width="36" height="36" />
  <rect x="473" y="442" class="st13" width="36" height="36" />
  <rect x="548" y="442" class="st13" width="36" height="36" />
  <rect x="510" y="442" class="st13" width="36" height="36" />
  <rect x="435" y="406" class="st13" width="36" height="36" />
  <rect x="585" y="405" class="st13" width="36" height="36" />
  <rect x="548" y="478" class="st13" width="36" height="36" />
  <rect x="473" y="478" class="st13" width="36" height="36" />
  <rect x="510" y="478" class="st13" width="36" height="36" />
  <rect x="483" y="524" class="st13" width="56" height="56" />
  <rect x="435" y="440" class="st13" width="36" height="36" />
  <rect x="435" y="478" class="st13" width="36" height="36" />
  <rect x="378" y="370" class="st13" width="56" height="56" />

  <g>
    <polygon
      class="st14"
      points="206,187 134,187 134,295 170,295 170,259 170,223 206,223 	"
    />
    <polygon
      class="st14"
      points="206,259 206,367 134,367 134,331 170,331 170,259 	"
    />
    <rect x="214" y="187" class="st15" width="36" height="108" />
    <polygon
      class="st15"
      points="286,187 286,259 250,259 250,367 286,367 286,295 322,295 322,187 	"
    />
    <rect x="329" y="259" class="st16" width="36" height="108" />
    <polygon
      class="st16"
      points="329,187 329,259 365,259 365,223 401,223 401,259 437,259 437,187 	"
    />
    <polygon
      class="st16"
      points="509,187 437,187 437,223 473,223 473,367 509,367 	"
    />
    <polygon
      class="st15"
      points="587,187 515,187 515,259 551,259 551,223 587,223 	"
    />
    <polygon
      class="st15"
      points="587,259 515,259 515,367 551,367 551,295 587,295 	"
    />
    <rect x="551" y="331" class="st15" width="36" height="36" />
    <polygon
      class="st14"
      points="592,187 592,223 628,223 628,259 664,259 664,223 700,223 700,187 	"
    />
    <rect x="628" y="259" class="st14" width="36" height="108" />
    <polygon
      class="st15"
      points="706,187 814,187 814,259 778,259 778,223 742,223 742,295 706,295 	"
    />
    <polygon
      class="st15"
      points="742,367 706,367 706,295 742,295 778,295 778,259 814,259 814,331 742,331 	"
    />
    <rect x="758" y="331" class="st15" width="36" height="36" />
    <rect x="819" y="187" class="st16" width="36" height="108" />
    <polygon
      class="st16"
      points="891,187 891,259 855,259 855,367 891,367 891,295 927,295 927,187 	"
    />
    <polyline class="st17" points="187,205 153,205 153,277 	" />
    <circle class="st16" cx="186.6" cy="205.4" r="5.9" />
    <circle class="st16" cx="152.5" cy="205" r="5.9" />
    <circle class="st16" cx="152.6" cy="241.4" r="5.9" />
    <circle class="st16" cx="152.6" cy="277.4" r="5.9" />
    <polyline class="st17" points="152.2,349.4 186.2,349.4 186.2,277.4 	" />
    <circle class="st16" cx="152.5" cy="349" r="5.9" />
    <circle class="st16" cx="186.6" cy="349.4" r="5.9" />
    <circle class="st16" cx="186.5" cy="313" r="5.9" />
    <circle class="st16" cx="186.5" cy="277" r="5.9" />
    <line class="st15" x1="232.4" y1="205.1" x2="232.4" y2="277.1" />
    <circle class="st15" cx="231.9" cy="205.1" r="5.9" />
    <circle class="st15" cx="232" cy="241.4" r="5.9" />
    <circle class="st15" cx="232" cy="277.4" r="5.9" />
    <polyline class="st18" points="268.8,277.4 302.8,277.4 302.8,205.4 	" />
    <circle class="st16" cx="269.2" cy="277.1" r="5.9" />
    <circle class="st15" cx="303.3" cy="277.4" r="5.9" />
    <circle class="st15" cx="303.2" cy="241.1" r="5.9" />
    <circle class="st15" cx="303.2" cy="205.1" r="5.9" />
    <line class="st15" x1="269.6" y1="277.1" x2="269.6" y2="349.1" />
    <circle class="st15" cx="269.2" cy="277.1" r="5.9" />
    <circle class="st15" cx="269.3" cy="313.4" r="5.9" />
    <circle class="st15" cx="269.3" cy="349.4" r="5.9" />
    <line class="st17" x1="346.9" y1="276.9" x2="346.9" y2="348.9" />
    <circle class="st16" cx="346.5" cy="276.9" r="5.9" />
    <circle class="st16" cx="346.6" cy="313.3" r="5.9" />
    <circle class="st16" cx="346.6" cy="349.3" r="5.9" />
    <line class="st17" x1="491.9" y1="276.9" x2="491.9" y2="348.9" />
    <circle class="st16" cx="491.5" cy="276.9" r="5.9" />
    <circle class="st16" cx="491.6" cy="313.3" r="5.9" />
    <circle class="st16" cx="491.6" cy="349.3" r="5.9" />
    <line class="st17" x1="491.9" y1="204.9" x2="491.9" y2="276.9" />
    <circle class="st16" cx="491.5" cy="204.9" r="5.9" />
    <circle class="st16" cx="491.6" cy="241.3" r="5.9" />
    <circle class="st16" cx="491.6" cy="277.3" r="5.9" />
    <line class="st17" x1="418.7" y1="204.5" x2="346.7" y2="204.5" />
    <circle class="st16" cx="418.7" cy="204" r="5.9" />
    <circle class="st16" cx="382.3" cy="204.1" r="5.9" />
    <circle class="st16" cx="349.3" cy="204.1" r="5.9" />
    <line class="st17" x1="348.9" y1="210" x2="349" y2="246" />
    <circle class="st16" cx="348.6" cy="240.4" r="5.9" />
    <line class="st17" x1="418.6" y1="208.9" x2="418.7" y2="244.8" />
    <circle class="st16" cx="418.2" cy="239.2" r="5.9" />
    <line class="st17" x1="487.7" y1="205.4" x2="451.7" y2="205.5" />
    <circle class="st16" cx="457.3" cy="205.1" r="5.9" />
    <polyline class="st18" points="568.9,277.1 534.9,277.1 534.9,349.1 	" />
    <circle class="st15" cx="568.5" cy="277.5" r="5.9" />
    <circle class="st15" cx="534.4" cy="277.1" r="5.9" />
    <circle class="st15" cx="534.5" cy="313.5" r="5.9" />
    <circle class="st15" cx="534.5" cy="349.5" r="5.9" />
    <polyline class="st15" points="568.9,204.1 534.9,204.1 534.9,235 	" />
    <circle class="st15" cx="568.5" cy="204.5" r="5.9" />
    <circle class="st15" cx="534.4" cy="204.1" r="5.9" />
    <circle class="st15" cx="534.5" cy="240.5" r="5.9" />
    <circle class="st15" cx="534.5" cy="276.5" r="5.9" />
    <circle class="st15" cx="568.2" cy="350" r="5.9" />
    <line class="st17" x1="646.4" y1="275.8" x2="646.4" y2="347.8" />
    <circle class="st16" cx="646" cy="312.2" r="5.9" />
    <circle class="st16" cx="646" cy="348.2" r="5.9" />
    <circle class="st16" cx="646" cy="276.9" r="5.9" />
    <line class="st17" x1="683.1" y1="204.5" x2="611.1" y2="204.5" />
    <circle class="st16" cx="646.8" cy="204.2" r="5.9" />
    <circle class="st16" cx="610.8" cy="204.2" r="5.9" />
    <circle class="st16" cx="682" cy="204.2" r="5.9" />
    <circle class="st16" cx="647.4" cy="238.2" r="5.9" />
    <line class="st16" x1="647" y1="210" x2="647" y2="233.4" />
    <line class="st15" x1="796.4" y1="205.6" x2="724.4" y2="205.6" />
    <circle class="st15" cx="796.5" cy="205.2" r="5.9" />
    <circle class="st15" cx="760.1" cy="205.3" r="5.9" />
    <circle class="st15" cx="727.1" cy="205.3" r="5.9" />
    <line class="st15" x1="725.7" y1="211.2" x2="725.8" y2="247.1" />
    <circle class="st15" cx="726.3" cy="241.5" r="5.9" />
    <line class="st15" x1="796.3" y1="210" x2="796.4" y2="245.9" />
    <circle class="st15" cx="796" cy="240.3" r="5.9" />
    <line class="st15" x1="795.3" y1="314.7" x2="723.3" y2="314.7" />
    <circle class="st15" cx="795.9" cy="280.3" r="5.9" />
    <circle class="st15" cx="758.9" cy="314.3" r="5.9" />
    <circle class="st15" cx="723.9" cy="314.3" r="5.9" />
    <circle class="st15" cx="795.9" cy="314.3" r="5.9" />
    <line class="st15" x1="796" y1="308" x2="796" y2="286" />
    <line class="st15" x1="724" y1="320" x2="724" y2="346" />
    <circle class="st15" cx="723.4" cy="346.3" r="5.9" />
    <circle class="st15" cx="776" cy="348" r="5.9" />
    <circle class="st15" cx="726.3" cy="274.8" r="5.9" />
    <line class="st15" x1="725.9" y1="246.6" x2="725.9" y2="270" />
    <line class="st17" x1="837.7" y1="201" x2="837.7" y2="273" />
    <circle class="st16" cx="837.4" cy="237.3" r="5.9" />
    <circle class="st16" cx="837.4" cy="273.3" r="5.9" />
    <circle class="st16" cx="837.4" cy="202.1" r="5.9" />
    <polyline class="st17" points="874.9,275.9 908.9,275.9 908.9,203.9 	" />
    <circle class="st16" cx="909.4" cy="275.9" r="5.9" />
    <circle class="st16" cx="909.3" cy="239.5" r="5.9" />
    <circle class="st16" cx="909.3" cy="203.5" r="5.9" />
    <circle class="st16" cx="875.3" cy="275.5" r="5.9" />
    <line class="st17" x1="875" y1="280" x2="875" y2="352" />
    <circle class="st16" cx="875.4" cy="311.9" r="5.9" />
    <circle class="st16" cx="875.4" cy="347.9" r="5.9" />
  </g>
  <rect x="425" y="68" class="st13" width="177" height="110" />
  <text transform="matrix(1 0 0 1 439.9858 125.8413)" class="st19 st20 st21"
    >UNBREAK</text
  >
  <text transform="matrix(1 0 0 1 491.5024 165.4219)" class="st22 st20 st23"
    >THE</text
  >
  <rect x="473" y="406" class="st13" width="75" height="72" />
  <text transform="matrix(1 0 0 1 494.4355 469.0527)" class="st16 st20 st24"
    >2</text
  >
</svg>
